module.exports = __webpack_public_path__ + "static/media/md-anderson-uth-no-name-black.a3891dae.svg";